import forecasOptionsComponent from './forecast-options.component';
import forecastBulletinComponent from './bulletin/forecast-bulletin.component';
import forecastProcessComponent from './process/forecasting-process.component';
import forecastComponent, {configStates} from './forecasting.component';
import forecastingTableComponent from './process/forecasting-table.component';
import forecastingSitesComponent from './process/forecasting-sites.component';

export default angular.module('imomo.forecast',[])
	.config(configStates)
	.component('imomoForecast', forecastComponent)
    .component('imomoForecastProcess', forecastProcessComponent)
    .component('imomoForecastOptions', forecasOptionsComponent)
    .component('imomoForecastBulletin', forecastBulletinComponent)
    .component('forecastingTable', forecastingTableComponent)
    .component('forecastingSites', forecastingSitesComponent)
    .name;



/** WEBPACK FOOTER **
 ** ./app/hydromet/forecasting/forecasting.module.ts
 **/